import React from 'react';
import { useParams } from 'react-router-dom';

import MultipleChoiceExercisePreview from '@ts-core/modules/multipleChoiceExercises/components/MultipleChoiceExercisePreview';

import { useMultipleChoiceExercise } from '../../hooks';

const MultipleChoiceExercisePreviewPage = () => {
  const { courseId, subjectId, exerciseId } = useParams<{ courseId: string; subjectId: string; exerciseId?: string }>();
  const { exercise, loading } = useMultipleChoiceExercise({ courseId, subjectId, exerciseId });

  return <MultipleChoiceExercisePreview exercise={exercise} loading={loading} hideNoAnswerOption hideQuestionBackgroundColor hideScores />;
};

export default MultipleChoiceExercisePreviewPage;
